module.exports = __webpack_public_path__ + "static/media/call.mp3?99c77bb303c6e822b9936429a4a05d7b";